export { setupMenus } from './setupMenus';
export {
  adaptMenuComponentStructure,
  connectMainMenuToComponent,
} from './setupCustomMenus/adaptMenuComponentStructure';
